module.exports = __webpack_public_path__ + "static/media/ELS160FL02.5b3531aa.png";